import { render, staticRenderFns } from "./TableCollapsibleRow.vue?vue&type=template&id=55abfd6a&scoped=true"
import script from "./TableCollapsibleRow.vue?vue&type=script&lang=js"
export * from "./TableCollapsibleRow.vue?vue&type=script&lang=js"
import style0 from "./TableCollapsibleRow.vue?vue&type=style&index=0&id=55abfd6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55abfd6a",
  null
  
)

export default component.exports